/**
 * Color adjustments
 *
 * @copyright 2018 Linguistica 360
 */

import $ from 'jquery';


const options = ['tooltips', 'background', 'highlight'];


function initCa() {
    options.forEach((option) => {
        const name = `ca-${option}`;
        if (localStorage.getItem(name)) $('body').addClass(name);
        else $('body').removeClass(name);
    });
}

export function setCa(option, value) {
    const name = `ca-${option}`;
    if (value) localStorage.setItem(name, true);
    else localStorage.removeItem(name);

    initCa();
}

export function getCa(option) {
    const name = `ca-${option}`;
    return !!localStorage.getItem(name);
}

initCa();
